// TODO: После полноценного внедрения Vue + PrimeVue + tailwind
// переписать данный компонент на Vue, а от данную реализацию необходимо удалить

import angular from 'angular';
import { angularComponent } from '@/legacy/helpers';

// Так-же удалить связанный `src/legacy/styles/_support-popup.scss` файл
class SuppurtPopupComponent {
  static $inject = ['$scope', '$element', '$document'];

  public opened: boolean = false;

  private onDocumentClick: (event: Event) => void;

  constructor(
    private $scope: angular.IScope,
    private $element: angular.IAugmentedJQuery,
    private $document: angular.IDocumentService,
  ) {
    // Сохраняем ссылку на обработчик для последующего удаления
    this.onDocumentClick = (event: Event) => {
      const clickedElement = event.target as HTMLElement;

      // Если клик был вне компонента — закрываем
      if (this.opened && !this.$element[0].contains(clickedElement)) {
        this.$scope.$apply(() => {
          this.close();
        });
      }
    };
  }

  public $onInit(): void {
    // Подписываемся на клик по документу
    this.$document.on('click', this.onDocumentClick);

    // Отписываемся при уничтожении компонента
    this.$scope.$on('$destroy', () => {
      this.$document.off('click', this.onDocumentClick);
    });
  }

  public close(): void {
    this.opened = false;
  }

  public open(): void {
    this.opened = true;
  }

  public toggle(): void {
    this.opened = !this.opened;
  }
}

angularComponent('suppurtPopup', {
  template: require('html-loader!./suppurt-popup.component.html')['default'],
  controller: SuppurtPopupComponent,
});